import { render, staticRenderFns } from "./BookmarkDeny.vue?vue&type=template&id=c13cb41a&"
import script from "./BookmarkDeny.vue?vue&type=script&lang=js&"
export * from "./BookmarkDeny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports